// src/com/veh_info/VehInfoSelectDialog.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import {
    DialogContent, Button, DialogActions,
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CheckIcon from '@mui/icons-material/Check';
import DoneIcon from '@mui/icons-material/Done'; // close the dialog.
import { AppWord, AppStyle, AppObject } from '../../value/AppConst';
import DraggableViewer from '../../common/DraggableViewer';
import FlexyTable from '../../common/flexytable/FlexyTable';
import { VehInfoDictionary } from './VehInfoDict';
import SearchBox from '../../common/SearchBox';
import { ContentHeader, CountLabel, ToolBox } from '../../common/TopViewControl';

const ContentBox = styled(Box)({
    maxHeight: '75vh', minHeight:'60vh',
    display: 'flex', flexDirection: 'column', 
});

const ControlBox = styled(Box)({
    display:'flex', alignItems:'center', paddingBottom: 10, flexGrow: 1,
});

export default function VehInfoSelectDialog({
    open,
    onClose,
    records,
    onSelect, // vehInfo object
    defaultSearchText = '',
}) {
    const [one, setOne] = useState({}); // get it from the records. (1st record)
    const [countToDisplay, setCountToDisplay] = useState(0);
    const [searchVehText, setSearchVehText] = useState('');

    useEffect(()=>{
        if(open && records.length > 0) {
            setOne(records[0]);
        }
        else setOne({});
    }, [records, open]);

    useEffect(()=>{
        if(open) setSearchVehText(defaultSearchText);
    }, [open, defaultSearchText]);

    const onChangeSearchVehText = (text) => {
        setSearchVehText(text);
    };

    const onClickToolOnRow = (toolId, row) => {
        if(toolId === AppObject.command.OK) {
            onSelect(row);
        }
    };

    const tableWidth = VehInfoDictionary.tableProps.columns.reduce((acc, cur) => acc + cur.width, 80);

    return (
        <DraggableViewer
            open={open}
            onClose={onClose}
            maxWidth='lg'
            title={
                one.vehPlates ?
                `${one.dcName}, ${one.comName}` :
                '차량 찾기'
            }
            startIcon={<LocalShippingIcon fontSize={AppWord.LARGE} />}
        >
            <DialogContent>
                <ContentBox minWidth={tableWidth}>
                    <ContentHeader>
                        <ControlBox>
                            <span style={{marginRight: 20, paddingTop: 10}}>
                                선택할 차량 행의 맨 끝 아이콘을 클릭하세요.
                            </span>
                            <SearchBox
                                value={searchVehText}
                                onChangeText={onChangeSearchVehText}
                            />
                        </ControlBox>
                        <ToolBox>
                            &nbsp; 차량 수: <CountLabel count={countToDisplay} countLabel={'대'} />
                        </ToolBox>
                    </ContentHeader>
                    <FlexyTable
                        name={VehInfoDictionary.tableProps.tableId}
                        tableProps={VehInfoDictionary.tableProps}
                        records={records}
                        search={searchVehText}
                        tools={[
                            {
                                id: AppObject.command.OK,
                                icon: <CheckIcon style={{
                                    color:'white', backgroundColor:'red', borderRadius: 20
                                }}/>
                            }
                        ]}
                        onClickTool={onClickToolOnRow}
                        onChangeCountToDisplay={setCountToDisplay}
                        hideBubble={true}
                    />
                </ContentBox>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color={AppStyle.mui.primary}
                    variant={AppStyle.mui.contained}
                    startIcon={<DoneIcon />}
                    fullWidth
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    )
}